import React, { useState } from 'react'
import { Spinner, Button } from 'react-bootstrap'
import { Divider, Empty } from 'antd'

import ResultActivityCard from './partials/ResultActivityCard'
import NewResultActivityModal from './partials/NewResultActivityModal'

export default function ResultActivitiesWidget({ serviceResult, reload }) {	
	const [showNewRecordModal, setShowNewRecordModal] = useState(false)

	if(!serviceResult) 
		return <Spinner animation='border' size="sm" />

	const resultActivities = serviceResult.result_activities

	return (
		<React.Fragment>
			{ resultActivities.length > 0 ? (
				<React.Fragment>
					{ resultActivities.map(item => (
						<ResultActivityCard 
							key={item.id}
							resultActivity={item}
							reload={reload}
							serviceResult={serviceResult}
						/>
					)) }
				</React.Fragment>
			) : (
				<Empty 
					description={`No se tiene actividades registradas`}
					styles={{ image: { maxHeight: '75px' } }}
				/>
			)}
			<Divider className='my-15' />
			<div className='text-center'>
				<Button 
					variant='outline-primary' 
					size="sm" 
					onClick={() => setShowNewRecordModal(true)}
				>
					Registrar Actividad
				</Button>
			</div>
			{ showNewRecordModal && (
				<NewResultActivityModal 
					visible
					onClose={() => setShowNewRecordModal(false)}
					reload={reload}
					serviceResult={serviceResult}
				/>
			)}
		</React.Fragment>
	)
}